import { getPageInfo } from "@/utils/helper"

const getPageType = () => {
  const page = getPageInfo()
  const {
    category: { pageType = "" },
  } = page
  return pageType
}

const addAnalyticsForNewsletterSignupOverlay = () => {
  const pageType = getPageType()

  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "newsletter signup overlay",
    eventMsg: "n/a",
    eventName: "newsletter signup overlay",
    eventStatus: "n/a",
    eventType: "popup",
    internalLinkName: "newsletter signup",
    internalLinkPosition: "newsletter signup",
    internalLinkType: "newsletter signup overlay",
    internalLinkURL: "n/a",
    internalLinkZoneName: `${pageType}:newsletter signup overlay`,
  }
  addAnalyticsForNewsletterSignup(eventInfo, "cmp:show")
}

const addAnalyticsForNewsletterSignupBtn = (eventStatus, eventMsg = "n/a") => {
  const pageType = getPageType()

  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "newsletter signup",
    eventMsg,
    eventName: "newsletter signup",
    eventStatus,
    eventType: "click",
    internalLinkName: "sign up",
    internalLinkPosition: "newsletter signup",
    internalLinkType: "newsletter signup overlay:submit",
    internalLinkURL: "n/a",
    internalLinkZoneName: `${pageType}:newsletter signup overlay`,
  }

  addAnalyticsForNewsletterSignup(eventInfo, "cmp:click")
}

const addAnalyticsForNewsletterSignupLinks = (type = "", url = "n/a") => {
  const linkName = type?.toLowerCase()
  const pageType = getPageType()
  const eventInfo = {
    clickInternalLinks: linkName === "close" ? "true" : "false",
    eventAction: `newsletter signup:${linkName}`,
    eventMsg: "n/a",
    eventName: `newsletter signup:${linkName}`,
    eventStatus: "n/a",
    eventType: "navigate",
    internalLinkName: linkName,
    internalLinkPosition: "newsletter signup",
    internalLinkType: `newsletter signup overlay:${linkName}`,
    internalLinkURL: url,
    internalLinkZoneName: `${pageType}:newsletter signup overlay`,
  }

  addAnalyticsForNewsletterSignup(eventInfo, "cmp:click")
}

const getRecaptchaAnalytics = {
  addNoFooterInAttr: true,
  pageTitle: "newsletter signup",
  internalLinkPosition: "newsletter signup",
  internalLinkTypeWithType: "newsletter signup overlay",
  internalLinkZoneName: "newsletter signup overlay",
}

const addAnalyticsForNewsletterSignup = (eventInfo, event) => {
  const page = getPageInfo()

  window.adobeDataLayer.push({
    event,
    eventInfo,
    page,
  })
}

export {
  addAnalyticsForNewsletterSignupOverlay,
  addAnalyticsForNewsletterSignupBtn,
  addAnalyticsForNewsletterSignupLinks,
  getRecaptchaAnalytics,
}
